import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useCart } from '../commerce/CartContext';
import { formatCurrency } from '../data';

const { FiMinus, FiPlus, FiTag, FiTrash2 } = FiIcons;

function CartPage() {
  const {
    items,
    subtotal,
    updateQuantity,
    removeItem
  } = useCart();
  const [promoCode, setPromoCode] = useState('');

  return (
    <main className="commerce-page cart-page">
      <header className="commerce-page-heading">
        <span className="eyebrow">Your Selection</span>
        <h1>Shopping Bag</h1>
        <p>Review your chosen pieces before secure checkout.</p>
      </header>

      {items.length === 0 ? (
        <section className="empty-state">
          <h2>Your bag is empty</h2>
          <p>Explore the ZEVI collection and add your preferred saree.</p>
          <Link className="gold-button" to="/shop">
            Continue shopping
          </Link>
        </section>
      ) : (
        <div className="cart-page-grid">
          <section className="cart-page-lines" aria-label="Cart products">
            {items.map((item) => (
              <article className="cart-page-line" key={item.key}>
                <img src={item.image} alt={item.imageAlt} />
                <div>
                  <h2>{item.name}</h2>
                  {item.variantName && <p>{item.variantName}</p>}
                  <strong>{formatCurrency(item.price)}</strong>
                  <div className="quantity-row">
                    <button
                      onClick={() => {
                        updateQuantity(item.key, item.quantity - 1);
                      }}
                      aria-label={`Decrease ${item.name} quantity`}
                    >
                      <SafeIcon icon={FiMinus} />
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() => {
                        updateQuantity(item.key, item.quantity + 1);
                      }}
                      aria-label={`Increase ${item.name} quantity`}
                    >
                      <SafeIcon icon={FiPlus} />
                    </button>
                    <button
                      className="remove-button"
                      onClick={() => removeItem(item.key)}
                      aria-label={`Remove ${item.name}`}
                    >
                      <SafeIcon icon={FiTrash2} />
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </section>

          <aside className="order-summary">
            <span className="eyebrow">Secure Checkout</span>
            <h2>Order Summary</h2>

            <label className="promo-field">
              Promo code
              <span>
                <SafeIcon icon={FiTag} />
                <input
                  value={promoCode}
                  onChange={(event) => setPromoCode(event.target.value)}
                  placeholder="Enter at checkout"
                />
              </span>
            </label>

            <div className="summary-line">
              <span>Subtotal</span>
              <strong>{formatCurrency(subtotal)}</strong>
            </div>
            <div className="summary-line">
              <span>Shipping</span>
              <strong>Calculated at checkout</strong>
            </div>
            <div className="total-row cart-final-row">
              <span>Current total</span>
              <strong>{formatCurrency(subtotal)}</strong>
            </div>

            <p>
              Final prices, discounts, stock, and delivery charges are
              calculated securely when the order is confirmed.
            </p>

            <Link
              className="gold-button"
              to="/checkout"
              state={{ promoCode: promoCode.trim() }}
            >
              Proceed to checkout
            </Link>
            <Link className="text-button" to="/shop">
              Continue shopping <span>→</span>
            </Link>
          </aside>
        </div>
      )}
    </main>
  );
}

export default CartPage;